import React from "react";
import { IonCard, IonCardContent, IonCol, IonContent, IonGrid, IonPage, IonRow } from "@ionic/react";
import PoweredBy from "../components/PoweredBy";

const Unauthorized : React.FC = () => {
    return (
        <IonPage>
            <IonContent className="content">
                <IonGrid style={{ paddingTop:"20px" }}>
                    <IonRow>
                        <IonCol
                            offsetXl="2"
                            sizeXl="8"
                        >
                            <IonCard>
                                <IonCardContent>
                                    <IonGrid>
                                        <IonRow>
                                            <IonCol
                                                offsetMd="4"
                                                sizeMd="4"                                            
                                                offsetSm="3"
                                                sizeSm="6"
                                            >
                                                <div className="ion-text-center not-found">401</div> 
                                            </IonCol>
                                        </IonRow>
                                        <IonRow>
                                            <IonCol
                                                offsetMd="4"
                                                sizeMd="4"                                            
                                                offsetSm="3"
                                                sizeSm="6"
                                            >
                                                <p className="subtitle">Sorry, your request could not be processed.</p>
                                            </IonCol>
                                        </IonRow>
                                    </IonGrid>
                                </IonCardContent>
                            </IonCard>
                        </IonCol>
                    </IonRow>
                </IonGrid>
                <PoweredBy />
            </IonContent>
        </IonPage>
    );
}

export default Unauthorized ;